import { i18n } from '@/i18n'

import isBlank from 'is-blank'
import {
  CONTENT_FILTER_REQUEST,
  CONTENT_FILTER_SUCCESS,
  CONTENT_FILTER_ERROR,
  SET_FOLDER_IDS,
  SET_TERM,
  SET_TAGS,
  SET_SOURCE_NAME,
  SET_INITIALIZED_AT_FROM,
  SET_INITIALIZED_AT_UNTIL,
  SET_CREATED_AT_FROM,
  SET_CREATED_AT_UNTIL,
  SET_PUBLISHED_AT_FROM,
  SET_PUBLISHED_AT_UNTIL,
  SET_COUNTRIES,
  SET_PRIORITY,
  SET_EXTERNAL,
  SET_SORT_BY,
  SET_SORT_DIR,
  SORT_BY_DEFAULT,
  SORT_DIRECTION_ASC,
  SORT_DIRECTION_DESC,
  SORT_DIRECTION_DEFAULT,
  SET_PAGE,
  SET_PER_PAGE,
  PER_PAGE_DEFAULT
} from './types'

export const state = {
  filter: {
    term: '',
    tags: [],
    folderIds: [],
    sourceName: '',
    initializedAtFrom: '',
    initializedAtUntil: '',
    createdAtFrom: '',
    createdAtUntil: '',
    publishedAtFrom: '',
    publishedAtUntil: '',
    countries: [],
    priority: '',
    external: '',
    sortBy: SORT_BY_DEFAULT,
    sortDir: SORT_DIRECTION_DEFAULT,
    page: 1,
    perPage: PER_PAGE_DEFAULT
  },
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [CONTENT_FILTER_REQUEST] (state) {
    state.request.isLoading = true
  },
  [CONTENT_FILTER_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [CONTENT_FILTER_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_FOLDER_IDS] (state, value) {
    state.filter.folderIds = value
  },
  [SET_TERM] (state, value) {
    state.filter.term = value
  },
  [SET_TAGS] (state, value) {
    state.filter.tags = value
  },
  [SET_SOURCE_NAME] (state, value) {
    state.filter.sourceName = value
  },
  [SET_INITIALIZED_AT_FROM] (state, value) {
    state.filter.initializedAtFrom = value
  },
  [SET_INITIALIZED_AT_UNTIL] (state, value) {
    state.filter.initializedAtUntil = value
  },
  [SET_CREATED_AT_FROM] (state, value) {
    state.filter.createdAtFrom = value
  },
  [SET_CREATED_AT_UNTIL] (state, value) {
    state.filter.createdAtUntil = value
  },
  [SET_PUBLISHED_AT_FROM] (state, value) {
    state.filter.publishedAtFrom = value
  },
  [SET_PUBLISHED_AT_UNTIL] (state, value) {
    state.filter.publishedAtUntil = value
  },
  [SET_COUNTRIES] (state, value) {
    state.filter.countries = value
  },
  [SET_PRIORITY] (state, value) {
    state.filter.priority = value
  },
  [SET_EXTERNAL] (state, value) {
    state.filter.external = value
  },
  [SET_SORT_BY] (state, value) {
    state.filter.sortBy = value
  },
  [SET_SORT_DIR] (state, value) {
    state.filter.sortDir = value
  },
  [SET_PAGE] (state, value) {
    state.filter.page = value
  },
  [SET_PER_PAGE] (state, value) {
    state.filter.perPage = value
  }
}

export const actions = {
  setFolderIds ({ commit }, value) {
    commit(SET_FOLDER_IDS, value)
  },
  setTerm ({ commit }, value) {
    commit(SET_TERM, value)
  },
  setTags ({ commit }, value) {
    commit(SET_TAGS, value)
  },
  setSourceName ({ commit }, value) {
    commit(SET_SOURCE_NAME, value)
  },
  setInitializedAtFrom ({ commit }, value) {
    commit(SET_INITIALIZED_AT_FROM, value)
  },
  setInitializedAtUntil ({ commit }, value) {
    commit(SET_INITIALIZED_AT_UNTIL, value)
  },
  setCreatedAtFrom ({ commit }, value) {
    commit(SET_CREATED_AT_FROM, value)
  },
  setCreatedAtUntil ({ commit }, value) {
    commit(SET_CREATED_AT_UNTIL, value)
  },
  setPublishedAtFrom ({ commit }, value) {
    commit(SET_PUBLISHED_AT_FROM, value)
  },
  setPublishedAtUntil ({ commit }, value) {
    commit(SET_PUBLISHED_AT_UNTIL, value)
  },
  setCountries ({ commit }, value) {
    commit(SET_COUNTRIES, value)
  },
  setPriority ({ commit }, value) {
    commit(SET_PRIORITY, value)
  },
  setExternal ({ commit }, value) {
    commit(SET_EXTERNAL, value)
  },
  setPage ({ commit }, value) {
    commit(SET_PAGE, value)
  },
  setPerPage ({ commit }, value) {
    commit(SET_PER_PAGE, value)
  },
  setSortBy ({ commit, state }, value) {
    if(state.filter.sortBy === value) {
      const dir = state.filter.sortDir === SORT_DIRECTION_ASC
        ? SORT_DIRECTION_DESC
        : SORT_DIRECTION_ASC
        commit(SET_SORT_DIR, dir)
    } else {
      commit(SET_SORT_DIR, SORT_DIRECTION_DEFAULT)
    }

    commit(SET_SORT_BY, value)
  },
  setSortDir ({ commit }, value) {
    commit(SET_SORT_DIR, value)
  },
  reset ({ commit }) {
    commit(SET_FOLDER_IDS, [])
    commit(SET_TERM, '')
    commit(SET_TAGS, [])
    commit(SET_SOURCE_NAME, '')
    commit(SET_INITIALIZED_AT_FROM, '')
    commit(SET_INITIALIZED_AT_UNTIL, '')
    commit(SET_CREATED_AT_FROM, '')
    commit(SET_CREATED_AT_UNTIL, '')
    commit(SET_PUBLISHED_AT_FROM, '')
    commit(SET_PUBLISHED_AT_UNTIL, '')
    commit(SET_COUNTRIES, [])
    commit(SET_PRIORITY, '')
    commit(SET_EXTERNAL, '')
    commit(SET_PAGE, 1)
    commit(SET_PER_PAGE, PER_PAGE_DEFAULT)
    commit(SET_SORT_BY, SORT_BY_DEFAULT)
    commit(SET_SORT_DIR, SORT_DIRECTION_DEFAULT)
  }
}

export const getters = {
  filterIsActive (state) {
    return !(
      isBlank(state.filter.tags) &&
      isBlank(state.filter.createdAtFrom) &&
      isBlank(state.filter.createdAtUntil) &&
      isBlank(state.filter.publishedAtFrom) &&
      isBlank(state.filter.publishedAtUntil) &&
      isBlank(state.filter.priority) &&
      isBlank(state.filter.external) &&
      isBlank(state.filter.sourceName) &&
      isBlank(state.filter.countries)
    )
  },
  sortByOptions () {
    return [
      { label: i18n.t('c.contentFilterForm.form.options.created_at'), value: 'created_at', active: state.filter.sortBy == 'created_at' },
      { label: i18n.t('c.contentFilterForm.form.options.published_at'), value: 'published_at', active: state.filter.sortBy == 'published_at' },
      { label: i18n.t('c.contentFilterForm.form.options.comments_count'), value: 'comments_count', active: state.filter.sortBy == 'comments_count' },
      { label: i18n.t('c.contentFilterForm.form.options.views'), value: 'views', active: state.filter.sortBy == 'views' }
    ]
  },
  sortDirOptions () {
    return [
      { label: i18n.t('c.contentFilterForm.form.options.asc'), value: 'asc' },
      { label: i18n.t('c.contentFilterForm.form.options.desc'), value: 'desc' }
    ]
  },
  priorityOptions () {
    return [
      { label: '', value: '' },
      { label: i18n.t('c.contentFilterForm.form.options.normal'), value: 'normal' },
      { label: i18n.t('c.contentFilterForm.form.options.high'), value: 'high' }
    ]
  },
  externalOptions () {
    return [
      { label: '', value: '' },
      { label: i18n.t('c.contentFilterForm.form.options.with_source_url'), value: 'with_source_url' },
      { label: i18n.t('c.contentFilterForm.form.options.without_source_url'), value: 'without_source_url' }
    ]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentFilter.js